import { useEffect } from "react";

/**
 * Custom React hook to set the document title.
 *
 * When the component using this hook is mounted, the document's title is set to the provided value.
 * When the component is unmounted or the title changes, the previous document title is restored.
 *
 * @param title - The title to set for the document.
 */
export function useTitle(title: string) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
}
